import React, { useCallback, useEffect } from 'react';

import { WizardCardList } from 'src/app/components/lib/wizard/card';

import { isDetailsStepValid } from '../../shared/helpers';
import { useDiscountWizardStateContext } from '../../state';
import { DetailsStepActions } from '../../state/details';

import { AvailabilityCard } from './availability-card';
import { EligibilityCard } from './eligibility-card';
import { ScheduleCard } from './schedule-card';

import type { WizardStepComponentProps } from 'src/app/components/lib/wizard';

export function Details({
  disableNextButton,
  enableNextButton,
  setComplete,
  setIncomplete,
  stepStatus,
}: WizardStepComponentProps) {
  const {
    detailsStepState: {
      activeDaysOfTheWeek,
      endDate,
      limitPerCustomer,
      limitPerCustomerQuantity,
      redemptionLimit,
      requireManagerApproval,
      restrictByDayOfWeek,
      specifyEndDate,
      startDate,
    },
    detailsStepDispatch,
  } = useDiscountWizardStateContext();

  const markStepComplete = useCallback(() => {
    enableNextButton();
    setComplete();
  }, [enableNextButton, setComplete]);

  const markStepIncomplete = useCallback(() => {
    disableNextButton();
    setIncomplete();
  }, [disableNextButton, setIncomplete]);

  useEffect(() => {
    detailsStepDispatch({ type: DetailsStepActions.VISITED }, true);
  }, [detailsStepDispatch]);

  useEffect(() => {
    const stepIsValid = isDetailsStepValid({
      activeDaysOfTheWeek,
      limitPerCustomer,
      limitPerCustomerQuantity,
      redemptionLimit,
      requireManagerApproval,
      restrictByDayOfWeek,
      startDate,
      specifyEndDate,
      endDate,
    });
    if (!stepIsValid && stepStatus.complete) {
      markStepIncomplete();
    }
    if (stepIsValid && !stepStatus.complete) {
      markStepComplete();
    }
  }, [
    activeDaysOfTheWeek,
    endDate,
    limitPerCustomer,
    limitPerCustomerQuantity,
    markStepComplete,
    markStepIncomplete,
    redemptionLimit,
    requireManagerApproval,
    restrictByDayOfWeek,
    specifyEndDate,
    startDate,
    stepStatus,
  ]);

  return (
    <WizardCardList $maxWidth='850px'>
      <EligibilityCard />
      <ScheduleCard />
      <AvailabilityCard />
    </WizardCardList>
  );
}
